import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import {
    DeletarPerguntaPesquisaController,
    ListarPerguntasERespostarFormController,
} from "../../../../../Controllers/Geral/Formularios/PerguntasERespostas/PerguntasERespostasControllers";

import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { IEditarPerguntasERespostasForm } from "../../../../../Interfaces/Geral/Formularios/FormulariosInterface";

import { AlertConfirmation } from "../../../../../Tools/SweetAlerts";
import HeaderPerguntasERespostas from "../HeaderPerguntasERespostas";

interface IListarPerguntasERespostasProps {
    idFormulario: number;
    setMostrarPerguntasERespostas: Dispatch<SetStateAction<boolean>>;
    setPerguntaSendoEditada: Dispatch<
        SetStateAction<IEditarPerguntasERespostasForm | undefined>
    >;
}

export default function ListarPerguntasERespostas(
    props: IListarPerguntasERespostasProps
) {
    const {
        value: ListarPerguntasERespostas,
        loading: ListarPerguntasERespostasLoading,
        execute: updateList,
    } = useAsyncEffect(async () =>
        ListarPerguntasERespostarFormController(props.idFormulario)
    );

    return (
        <>
            <OrSpinner
                loading={ListarPerguntasERespostasLoading}
                spinner="capys"
            >
                <HeaderPerguntasERespostas
                    setMostrarPerguntasERespostas={
                        props.setMostrarPerguntasERespostas
                    }
                />
                {ListarPerguntasERespostas?.ListaPesquisaSatisfacaoPerguntaRespostas.map(
                    (pergunta, index) => (
                        <div key={pergunta.ID_PERGUNTA}>
                            <div className="d-flex align-items-center g-3 ml-8 row">
                                <h4 className="mt-3 mb-4 ">
                                    {pergunta.DS_PERGUNTA}

                                    <FontAwesomeIcon
                                        onClick={() => {
                                            props.setPerguntaSendoEditada(
                                                ListarPerguntasERespostas
                                                    .ListaPesquisaSatisfacaoPerguntaRespostas[
                                                    index
                                                ]
                                            );
                                            props.setMostrarPerguntasERespostas(
                                                false
                                            );
                                        }}
                                        className="cursor-pointer text-primary ml-2"
                                        icon={faEdit}
                                        size="1x"
                                    />

                                    <FontAwesomeIcon
                                        className="cursor-pointer text-danger ml-2"
                                        icon={faTrash}
                                        size="1x"
                                        onClick={() => {
                                            AlertConfirmation(
                                                "Esta pergunta será excluida permanentemente",
                                                "Confirmar?",
                                                "warning"
                                            ).then((result) => {
                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {
                                                    DeletarPerguntaPesquisaController(
                                                        pergunta.ID_PERGUNTA
                                                    ).then((response) => {
                                                        updateList();
                                                    });
                                                }
                                            });
                                        }}
                                    />
                                </h4>
                            </div>

                            <div className="d-flex flex-wrap">
                                <ul className="row d-flex justify-content-center">
                                    {(pergunta.PesquisaSatisfacaoRespostas
                                        ?.length || []) > 0
                                        ? pergunta.PesquisaSatisfacaoRespostas?.map(
                                              (resposta, index) => (
                                                  <div
                                                      key={resposta.ID_RESPOSTA}
                                                      className="d-flex align-items-center flex-wrap "
                                                  >
                                                      <li className="list-group-item d-flex mr-4 mb-3 justify-content-center">
                                                          {resposta.DS_RESPOSTA}
                                                      </li>
                                                  </div>
                                              )
                                          )
                                        : pergunta.PerguntasFilhas?.map(
                                              (respostaPai, index) =>
                                                  respostaPai.PesquisaSatisfacaoRespostas.map(
                                                      (resposta) => (
                                                          <>
                                                              <div
                                                                  key={
                                                                      resposta.ID_RESPOSTA
                                                                  }
                                                                  className="d-flex align-items-center flex-wrap "
                                                              >
                                                                  <li className="list-group-item d-flex mr-4 mb-3 justify-content-center">
                                                                      {
                                                                          resposta.DS_RESPOSTA
                                                                      }
                                                                  </li>
                                                              </div>
                                                          </>
                                                      )
                                                  )
                                          )}
                                </ul>
                            </div>

                            <hr />
                        </div>
                    )
                )}
            </OrSpinner>
        </>
    );
}
